enum RoleTypes {
  USER = 'user',
  DEPOT_ADMIN = 'depot_admin',
  DISTRIBUTOR_ADMIN = 'distributor'
}

const hasRole = (roles: Array<RoleTypes>, role: RoleTypes) => {
  return roles.includes(role);
};

export { hasRole, RoleTypes };
